var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/document-request'], function($, core, BaseCollection, DocumentRequestModel) {
  var DocumentRequestCollection, apiPrefix;
  apiPrefix = core.getConfig().apiPrefix;
  return DocumentRequestCollection = (function(_super) {

    __extends(DocumentRequestCollection, _super);

    function DocumentRequestCollection() {
      DocumentRequestCollection.__super__.constructor.apply(this, arguments);
    }

    DocumentRequestCollection.prototype.path = function() {
      return apiPrefix + 'documentrequest.json/client/' + core.getCurrentClientId() + '/requests/pending';
    };

    DocumentRequestCollection.prototype.model = DocumentRequestModel;

    DocumentRequestCollection.prototype.filterDocType = function(documentType) {
      var filtered;
      if (documentType === "OTHER") {
        filtered = this.filter(function(docRequests) {
          return ['RECEIPT', 'TRANSACTIONAL', 'STATEMENT', 'TAX', 'EXPORTS', 'PAYROLL_REPORT', 'EXPENSE_REPORT', 'MERCHANT_REPORT', 'LOAN_INTEREST_REPORT', 'INTERNAL'].every(function(x) {
            return x !== docRequests.get('documentType');
          });
        });
      } else if (documentType === "PAYROLL_REPORT" || documentType === "EXPENSE_REPORT" || documentType === 'MERCHANT_REPORT' || documentType === 'LOAN_INTEREST_REPORT') {
        filtered = this.filter(function(docRequests) {
          return docRequests.attributes.documentType === 'PAYROLL_REPORT' || docRequests.attributes.documentType === 'EXPENSE_REPORT' || docRequests.attributes.documentType === 'MERCHANT_REPORT' || docRequests.attributes.documentType === 'LOAN_INTEREST_REPORT';
        });
      } else {
        filtered = this.filter({
          documentType: documentType
        });
      }
      return new DocumentRequestCollection(filtered);
    };

    return DocumentRequestCollection;

  })(BaseCollection);
});
